<section class="bg-gray-50">
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <a href="/" class="flex items-center mb-6 text-2xl font-semibold text-gray-900">
            <img class="w-40 h-40 mr-2 object-contain bg-blue-600 p-2" src="assets/images/logo.png" alt="La Bourrée de Paris, retour à l'accueil">
        </a>
        <div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
            <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                    Connexion
                </h1>
                <form [formGroup]="loginForm" (ngSubmit)="login()" class="space-y-4 md:space-y-6" action="#">
                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Email</label>
                        <input formControlName="email" type="email" name="email" id="email" autocomplete="email" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5" placeholder="name@company.com" required="">
                    </div>
                    <div>
                        <label for="password" class="block mb-2 text-sm font-medium text-gray-900">Mot de passe</label>
                        <input formControlName="password" type="password" name="password" id="password" autocomplete="current-password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5" required="">
                    </div>
                    <button type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Se connecter</button>
                    <div>
                        <p class="text-sm font-light text-gray-600 text-center">Pas de compte ? Contactez l'administrateur !</p>
                    <p class="text-sm font-light text-gray-600 text-center">Mot de passe oublié ? <button type="button" (click)="resetPassword()" class="cursor-pointer font-medium text-blue-700 underline">Réinitialisez-le !</button></p>
                    </div>
                    <p class="text-xs text-gray-600 text-center">
                        <a href="/mentions-legales" class="underline">Mentions légales</a> ·
                        <a href="/confidentialite" class="underline">Confidentialité</a> ·
                        <a href="/cgu" class="underline">Conditions d'utilisation</a>
                    </p>
                </form>
            </div>
        </div>
    </div>
  </section>
  <app-toast></app-toast>